import * as z from 'zod'
import Rosettas from './rosettas'
import type { ColeccionDeTraducciones, MicRosetta as Rosetta } from './rosettas'

interface ErrorNotificable {
  icono: string
  traducciones: Rosetta
}

type RegistroDeErroresNotificables = Record<string, ErrorNotificable>

// erroresComunes Errores comunes
export const erroresNotificables: RegistroDeErroresNotificables = {
  actividadSospechosa: {
    icono: 'solar:incognito-bold',
    traducciones: {
      es: 'Actividad sospechosa detectada',
      en: 'Suspicious activity detected',
      pt: 'Atividade sospeita detectada'
    }
  },
  lentoPeroSeguro: {
    icono: 'f7:tortoise-fill',
    traducciones: {
      es: 'Lento, pero seguro',
      en: 'Slow, but secure',
      pt: 'Lento, mas seguro'
    }
  },
  ErrorInesperado: {
    icono: 'solar:cloud-bolt-bold-duotone',
    traducciones: {
      es: 'Error inesperado',
      en: 'Unexpected error',
      pt: 'Erro inesperado'
    }
  },
  noExisteConfigPrincipal: {
    icono: 'solar:clound-cross-bold-duotone',
    traducciones: {
      es: 'Configuración principal no encontrada',
      en: 'Main configuration not found',
      pt: 'Configuração principal não encontrada'
    }
  },
  appNoAutorizada: {
    icono: 'octicon:no-entry-24',
    traducciones: {
      es: 'App no autorizada',
      en: 'App not authorized',
      pt: 'App não autorizado'
    }
  },
  gimNoAutorizado: {
    icono: 'octicon:no-entry-24',
    traducciones: {
      es: 'Gimnasio no autorizado en esta app',
      en: 'Gym not authorized in this app',
      pt: 'Academia não autorizada neste app'
    }
  },
  usuarioNoTienePermiso: {
    icono: 'octicon:no-entry-24',
    traducciones: {
      es: 'Usuario no tiene permiso',
      en: 'User does not have permission',
      pt: 'Usuário não tem permissão'
    }
  },
  usuarioNoAutorizado: {
    icono: 'solar:shield-up-bold-duotone',
    traducciones: {
      es: 'Usuario no autorizado',
      en: 'Unauthorized user',
      pt: 'Usuário não autorizado'
    }
  },
  usuarioNoEncontrado: {
    icono: 'solar:magnifer-broken',
    traducciones: {
      es: 'Usuario no encontrado',
      en: 'User not found',
      pt: 'Usuário não encontrado'
    }
  },
  emailNoRegistrado: {
    icono: 'solar:mailbox-bold-duotone',
    traducciones: {
      es: 'Email no registrado',
      en: 'Email not registered',
      pt: 'Email não registrado'
    }
  },
  emailYaRegistrado: {
    icono: 'fluent:person-lock-20-regular',
    traducciones: {
      es: 'Email ya registrado, puedes intentar ingresar con tu contraseña o configurar una nueva si no la recuerdas',
      en: 'Email already registered, you can try to login with your password or set a new one if you don\'t remember it',
      pt: 'Email já registrado, você pode tentar fazer login com sua senha ou definir uma nova se não se lembrar dela'
    }
  },
  passwordNoExiste: {
    icono: 'fluent:shield-question-32-filled',
    traducciones: {
      es: 'Password no existe',
      en: 'Password does not exist',
      pt: 'Senha não existe'
    }
  },
  passwordIncorrecto: {
    icono: 'fluent:shield-keyhole-24-filled',
    traducciones: {
      es: 'Password incorrecto',
      en: 'Incorrect password',
      pt: 'Senha incorreta'
    }
  },
  emailNoUtilizable: {
    icono: 'solar:mailbox-broken',
    traducciones: {
      es: 'Email no utilizable',
      en: 'Email not usable',
      pt: 'Email não utilizável'
    }
  },
  tokenExpirado: {
    icono: 'fluent:settings-chat-24-regular',
    traducciones: {
      es: 'Tu sesión ha expirado',
      en: 'Your session has expired',
      pt: 'Sua sessão expirou'
    }
  },
  tokenInvalido: {
    icono: 'solar:shield-bold-duotone',
    traducciones: {
      es: 'Token de sesión inválido',
      en: 'Invalid session token',
      pt: 'Token de sessão inválido'
    }
  },
  errorDeConexion: {
    icono: 'solar:cloud-bolt-bold-duotone',
    traducciones: {
      es: 'Error de conexión',
      en: 'Connection error',
      pt: 'Erro de conexão'
    }
  },
  conexionFallidaDB: {
    icono: 'fluent:database-plug-connected-20-regular',
    traducciones: {
      es: 'DB desconectada',
      en: 'DB disconnected',
      pt: 'DB desconectada'
    }
  },
  conexionRechazadaSDB: {
    icono: 'solar:bolt-broken',
    traducciones: {
      es: 'Conexión rechazada por el servidor de base de datos',
      en: 'Connection rejected by the database server',
      pt: 'Conexão rejeitada pelo servidor de banco de dados'
    }
  },
  conexionFallidaSDB: {
    icono: 'solar:bolt-broken',
    traducciones: {
      es: 'Falló la conexión con el servidor de base de datos',
      en: 'Connection to the database server failed',
      pt: 'Falha na conexão com o servidor de banco de dados'
    }
  },
  errorDeServidor: {
    icono: 'solar:cloud-storm-outline',
    traducciones: {
      es: 'Error de servidor',
      en: 'Server error',
      pt: 'Erro de servidor'
    }
  },
  appDesactivada: {
    icono: 'solar:bolt-broken',
    traducciones: {
      es: 'App desactivada',
      en: 'App deactivated',
      pt: 'App desativado'
    }
  },
  falloSolicitud: {
    icono: 'solar:bolt-broken',
    traducciones: {
      es: 'Falló la solicitud',
      en: 'Request failed',
      pt: 'Solicitação falhou'
    }
  },
  falloElIngreso: {
    icono: 'carbon:retry-failed',
    traducciones: {
      es: 'Falló el ingreso',
      en: 'Login failed',
      pt: 'Falha no login'
    }
  },
  falloElRegistro: {
    icono: 'carbon:retry-failed',
    traducciones: {
      es: 'Falló el registro',
      en: 'Registration failed',
      pt: 'Falha no registro'
    }
  },
  plataformaEnMantencion: {
    icono: 'icon-park-twotone:worker',
    traducciones: {
      es: 'Plataforma en mantención',
      en: 'Platform in maintenance',
      pt: 'Plataforma em manutenção'
    }
  },
  noSePudoSolicitarCambioDePassword: {
    icono: 'ph:password-duotone',
    traducciones: {
      es: 'No se pudo solicitar el cambio de contraseña',
      en: 'The password change request could not be made',
      pt: 'Não foi possível solicitar a alteração de senha'
    }
  },
  noExisteUnaCuentaConEsteEmail: {
    icono: 'solar:mailbox-broken',
    traducciones: {
      es: 'No existe una cuenta con este email',
      en: 'There is no account with this email',
      pt: 'Não existe uma conta com este email'
    }
  },
  peroPuedesCrearUna: {
    icono: 'solar:mailbox-broken',
    traducciones: {
      es: 'pero puedes crear una',
      en: 'but you can create one',
      pt: 'mas você pode criar uma'
    }
  },

  falloObtencionToken: {
    icono: 'solar:plug-circle-line-duotone',
    traducciones: {
      es: 'Fallo la obtención del token',
      en: 'Failed to get token',
      pt: 'Falha ao obter o token'
    }
  },
  noExisteUsuarioID: {
    icono: 'solar:user-broken',
    traducciones: {
      es: 'No existe el usuario',
      en: 'User does not exist',
      pt: 'Usuário não existe'
    }
  },
  falloLaEliminacionDeLaCuenta: {
    icono: 'solar:trash-bin-minimalistic-broken',
    traducciones: {
      es: 'Falló la eliminación de la cuenta',
      en: 'Failed to delete the account',
      pt: 'Falha ao excluir a conta'
    }
  },

  codigoInvalido: {
    icono: 'iconoir:password-error',
    traducciones: {
      es: 'El código no es válido',
      en: 'The code is not valid',
      pt: 'O código não é válido'
    }
  },
  cambioDePasswordFallido: {
    icono: 'mdi:security-close',
    traducciones: {
      es: 'Cambio de password fallido',
      en: 'Password change failed',
      pt: 'Falha na alteração de senha'
    }
  },
  operacionNoSolicitada: {
    icono: 'material-symbols:detection-and-zone',
    traducciones: {
      es: 'Operación no solicitada',
      en: 'Operation not requested',
      pt: 'Operação não solicitada'
    }
  },
  sistemaNoLoPermite: {
    icono: 'solar:danger-outline',
    traducciones: {
      es: 'El sistema no lo permite',
      en: 'The system does not allow it',
      pt: 'O sistema não permite'
    }
  },
  'Failed to fetch': {
    icono: 'hugeicons:wifi-disconnected-03',
    traducciones: {
      es: 'No se pudo conectar con el servidor',
      en: 'Could not connect to the server',
      pt: 'Não foi possível conectar ao servidor'
    }
  },
  llaveroNoEncontrado: {
    icono: 'solar:shield-cross-bold-duotone',
    traducciones: {
      es: 'Dispositivo no reconocido, generando nuevo acceso',
      en: 'Device not recognized, generating new access',
      pt: 'Dispositivo não reconhecido, gerando novo acesso'
    }
  }
} as const

// Extraer las claves utilizando keyof typeof
export type ErroresNotificablesIDs = keyof typeof erroresNotificables

export const ErrorNotificableZod = z.custom<ErroresNotificablesIDs>((val) => {
  if (typeof val !== 'string') {
    consolo.error('ErrorNotificableZod: val no es string, val:', val)
    return false
  }
  const errorRegistrado = Object.hasOwnProperty.call(erroresNotificables, val)
  if (!errorRegistrado) {
    consolo.error('usoDiario ErrorNotificableZod: error no registrado, val:', val)
    return false
  }
  return true
})

const iconosDeTraducciones: Record<string, string> = {}
const coleccionDeRosettas: ColeccionDeTraducciones = {}

for (const [codigoError, { traducciones, icono }] of Object.entries(
  erroresNotificables
)) {
  coleccionDeRosettas[codigoError] = traducciones
  iconosDeTraducciones[codigoError] = icono
}

export const i18nIconos = iconosDeTraducciones
export const i18nTapi = Rosettas.crear(coleccionDeRosettas)
